var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ClientRatingSummaryMapper } from "@domains/salesFeatures/Profile/mapper/ClientRatingsSummaryMapper";
import profileUrlConfig from "@adapters/infrastructures/urlConfig/SalesJourney/Profile/ProfileURL";
import { RmRatingDetailsMapper } from "@domains/salesFeatures/Profile/mapper/RmRatingDetailsMapper";
import { getUserRoutesMapper } from "@domains/salesFeatures/Profile/mapper/GetUserRoutesMapper";
import supersetReportingURL from "@adapters/infrastructures/urlConfig/SalesJourney/Reporting/SupersetReportingURL";
import leadUrlConfig from "@adapters/infrastructures/urlConfig/SalesJourney/Lead/LeadURL";
var ProfileRepository = /** @class */ (function () {
    function ProfileRepository(http) {
        this.http = http;
    }
    ProfileRepository.prototype.saveDashboardFeedback = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.addfeedback);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    ProfileRepository.prototype.getAbsenteeData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.getAbsenteeData);
                        if (req === null || req === void 0 ? void 0 : req.userId) {
                            url.searchParams.append("fromDate", req === null || req === void 0 ? void 0 : req.userId);
                        }
                        if (req === null || req === void 0 ? void 0 : req.fromDate) {
                            url.searchParams.append("fromDate", req === null || req === void 0 ? void 0 : req.fromDate);
                        }
                        if (req === null || req === void 0 ? void 0 : req.toDate) {
                            url.searchParams.append("fromDate", req === null || req === void 0 ? void 0 : req.toDate);
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    ProfileRepository.prototype.downloadAbsenteeFile = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.downloadAbsenteeFile);
                        url.searchParams.append("fileName", req.fileName);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ProfileRepository.prototype.getAbsenteeSampleFile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.absenteeSampleFile);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    ProfileRepository.prototype.getAccountOpeningUrls = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.getAccountOpeningUrls);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    ProfileRepository.prototype.getMarkAbsentee = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.markAbsentee);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    ProfileRepository.prototype.getValidateFeedbackData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.validatefeedback);
                        url.searchParams.append("submoduleCode", req.submoduleCode.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    ProfileRepository.prototype.getDocumentUpload = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.documentUpload);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ProfileRepository.prototype.getSupersetMenuList = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(supersetReportingURL.supersetMenuList);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ProfileRepository.prototype.getUserMenu = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, routeList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.getUserMenu);
                        url.searchParams.append("strPartnerCategory", req.strPartnerCategory);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        routeList = _a.sent();
                        return [2 /*return*/, getUserRoutesMapper(routeList === null || routeList === void 0 ? void 0 : routeList.data)];
                }
            });
        });
    };
    ProfileRepository.prototype.savePreference = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, savedPrefrenceData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.savePreference);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        savedPrefrenceData = _a.sent();
                        return [2 /*return*/, savedPrefrenceData.data];
                }
            });
        });
    };
    ProfileRepository.prototype.getPreference = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, getPrefrence;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.getPrefrence);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        getPrefrence = _a.sent();
                        return [2 /*return*/, getPrefrence.data];
                }
            });
        });
    };
    ProfileRepository.prototype.getUPCData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, upcData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.getUPCData);
                        url.searchParams.append("searchValue", req.searchValue);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        upcData = _a.sent();
                        return [2 /*return*/, upcData];
                }
            });
        });
    };
    ProfileRepository.prototype.getSocialMediaDetails = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, socialMediaDetailsData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.getSocialMediaDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        socialMediaDetailsData = _a.sent();
                        return [2 /*return*/, socialMediaDetailsData.data];
                }
            });
        });
    };
    ProfileRepository.prototype.getClientRatingSummaryDetailsEntity = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, clientRatingSummaryData, clientRatingEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(profileUrlConfig.ClientRatingSummaryDetails);
                        if (req.tier !== null && req.tier !== undefined)
                            url.searchParams.append("tier", req.tier);
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        clientRatingSummaryData = _b.sent();
                        clientRatingEntity = [];
                        if (clientRatingSummaryData && ((_a = clientRatingSummaryData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            clientRatingEntity = clientRatingSummaryData.data;
                        }
                        return [2 /*return*/, clientRatingEntity];
                }
            });
        });
    };
    ProfileRepository.prototype.getClientRatingSummaryEntity = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, clientRatingSummaryData, clientRatingEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(profileUrlConfig.clientRatingSummaryNew);
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        clientRatingSummaryData = _b.sent();
                        clientRatingEntity = [];
                        if (clientRatingSummaryData && ((_a = clientRatingSummaryData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            clientRatingEntity = clientRatingSummaryData.data;
                        }
                        return [2 /*return*/, clientRatingEntity];
                }
            });
        });
    };
    ProfileRepository.prototype.updateOnDeskDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, updateOnDesk;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.updateOnDeskDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        updateOnDesk = _a.sent();
                        return [2 /*return*/, updateOnDesk.data];
                }
            });
        });
    };
    ProfileRepository.prototype.getONDeskDetails = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, onDeskDetails;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.getOnDeskDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        onDeskDetails = _a.sent();
                        return [2 /*return*/, onDeskDetails.data];
                }
            });
        });
    };
    ProfileRepository.prototype.getRMDetailRatings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, rmDetailRating, ratingResultEntity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.rmRatingDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        rmDetailRating = _a.sent();
                        ratingResultEntity = {
                            data: [],
                        };
                        ratingResultEntity.data = rmDetailRating.data;
                        return [2 /*return*/, RmRatingDetailsMapper(rmDetailRating.data)];
                }
            });
        });
    };
    ProfileRepository.prototype.getRatings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, ratingsDetails, dataEntity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.rmRatings);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        ratingsDetails = _a.sent();
                        dataEntity = {
                            ratingsDetails: {},
                        };
                        if (ratingsDetails.data) {
                            dataEntity.ratingsDetails = ratingsDetails.data[0];
                        }
                        return [2 /*return*/, dataEntity];
                }
            });
        });
    };
    ProfileRepository.prototype.getProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, profileData, dataEntity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.profileDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        profileData = _a.sent();
                        dataEntity = {
                            profileDetails: {},
                        };
                        if (profileData.data)
                            dataEntity.profileDetails = profileData.data;
                        return [2 /*return*/, dataEntity];
                }
            });
        });
    };
    ProfileRepository.prototype.getClientRatingSummary = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, profileData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.clientRatingSummary +
                            "?pageno=" +
                            req.pageno +
                            "&pageSize=" +
                            req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        profileData = _a.sent();
                        return [2 /*return*/, ClientRatingSummaryMapper(profileData.data)];
                }
            });
        });
    };
    ProfileRepository.prototype.getCriticalActivity = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.creaticalDetails + "?page=1&pageSize=100");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1: 
                    // let criticalActivity =
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ProfileRepository.prototype.getProfileImage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, profileImage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.profileImageDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        profileImage = _a.sent();
                        return [2 /*return*/, profileImage.data];
                }
            });
        });
    };
    ProfileRepository.prototype.postSocialMedia = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, socialMediaData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.postSocialMedia);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        socialMediaData = _a.sent();
                        return [2 /*return*/, socialMediaData.data];
                }
            });
        });
    };
    ProfileRepository.prototype.postProfileImage = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, profileImage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(profileUrlConfig.postProfileImage);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.imagestring,
                            })];
                    case 1:
                        profileImage = _a.sent();
                        return [2 /*return*/, profileImage.data];
                }
            });
        });
    };
    return ProfileRepository;
}());
export default ProfileRepository;
